import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_household_diy: FaireCategoryEntity = {
  token: "catalog_cat_household-diy",
  type: "category",
  name: "Household supplies & DIY",
  count: 30,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
